interface ContentAuthorBadgeProps {
  author: string; // "ai" = AI, string = human name
  photo?: string; // Optional path to author's photo (small circle)
  role?: string; // Optional role (e.g., "Customer Success Manager")
  inline?: boolean; // If true, render as inline element
}

export function ContentAuthorBadge({
  author,
  photo,
  role,
  inline = false,
}: ContentAuthorBadgeProps) {
  // Determine if this is AI-generated content
  const isAI =
    author.toLowerCase() === "ai" || author.toLowerCase() === "jane ai";

  // Use full name for human authors, "Jane AI" for AI
  const displayName = isAI ? "Jane AI" : author;

  // Color schemes
  const colors = isAI
    ? {
        text: "text-emerald-400",
        icon: "text-emerald-400",
      }
    : {
        text: "text-amber-300",
        icon: "text-amber-400",
      };

  const content = (
    <>
      {/* Photo or icon/em-dash */}
      {photo && !isAI ? (
        <img
          src={photo}
          alt={displayName}
          className="w-8 h-8 rounded-full object-cover shrink-0"
        />
      ) : isAI ? (
        // Sparkle icon for AI
        <svg
          className={`w-3 h-3 ${colors.icon} shrink-0`}
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
        </svg>
      ) : (
        // Em-dash for human authors without photo
        <span className={`${colors.text} font-normal`}>—</span>
      )}
      <div className="flex flex-col">
        <span className={`${colors.text} font-medium`}>{displayName}</span>
        {role && !isAI && (
          <span className={`${colors.text} text-xs opacity-70`}>{role}</span>
        )}
      </div>
    </>
  );

  if (inline) {
    return (
      <span className="inline-flex items-center gap-1.5 ml-2">{content}</span>
    );
  }

  return <div className="flex items-center gap-1.5 mt-1">{content}</div>;
}
